import PageLink from '@/components/page-link';
import PolicyCardList from '@/components/policy-card-list';
import Text from '@/components/text';
import InlineToast from '@/components/toasts/inline';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { FC } from 'react';

interface Props {
  policies: PolicyModelV1[];
}

const ClassifierPolicies: FC<Props> = ({ policies }) => {
  const hasPolicies = !!policies.length;

  if (!hasPolicies) {
    return (
      <InlineToast
        message={
          <Text size="small">
            No policies found for this classifier. To start taking action based on classifier, head
            over to{' '}
            <PageLink
              routeKey="default-policy"
              scrollId="intent-controls"
              size="small"
              search={{ tab: 'classifiers' }}
            />{' '}
            or to <PageLink routeKey="group-policies" size="small" />.
          </Text>
        }
      />
    );
  }

  return <PolicyCardList policies={policies} />;
};

export default ClassifierPolicies;
